import { StatusWidgetContainer } from '@apps-common/apps/portal/pages/units/pages/manage/components'

export const LoadingStatus = () => (
  <StatusWidgetContainer>
    <div className='animate-pulse flex flex-col gap-[3px] items-center justify-center px-[4px] py-[5px]'>
      <div className='w-[50px] h-[40px] flex justify-center bg-skeleton rounded-xl mx-auto' />
      {/* <div className='h-[0.7rem] bg-skeleton rounded-xl w-[90%]' /> */}
    </div>
  </StatusWidgetContainer>
)
